import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface OurMarkdownProps {
  content: string;
}

export const OurMarkdown = (props: OurMarkdownProps) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        p: props => <p className="whitespace-pre-wrap" {...props} />,
        ul: props => <ul className="list-disc pl-5" {...props} />,
        ol: props => <ol className="list-decimal pl-5" {...props} />,
        li: props => <li className="my-1" {...props} />,
        a: props => <a className="underline" target="_blank" rel="noreferrer" {...props} />,
        code: props => <code className="font-mono text-[0.85em] bg-black/5 px-1 py-0.5 rounded" {...props} />,
        pre: props => <pre className="font-mono text-[0.85em] bg-black/5 p-2 rounded overflow-x-auto" {...props} />,
        blockquote: props => <blockquote className="border-l-4 border-gray-300 pl-3 text-gray-700" {...props} />,
      }}
    >
      {props.content}
    </ReactMarkdown>
  );
};
